import * as React from 'react';

import { ClassRelationshipItem } from 'src/containers/ProjectDiagram/components/classDrawer/types';
import { useGenerateNewIri } from 'src/containers/ProjectDiagram/hooks/entityDrawer/useGenerateNewIri';
import { generateModelConceptIri } from 'src/containers/ProjectDiagram/utils/generateProjectIri';
import { projectSelector } from 'src/selectors/project';
import { getProjectTargetModel } from 'src/utils/getProjectTargetModel';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useCreateModelConceptRelationshipFromQuery = (
  existingIris?: Set<string>
) => {
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const generateNewIri = useGenerateNewIri();

  return React.useCallback(
    (query: string): ClassRelationshipItem => {
      const text = query.trim();

      if (!project) {
        return { text, value: '', isNewlyCreated: true, directions: [] };
      }

      const initialValue = generateModelConceptIri(
        getProjectTargetModel(project),
        text
      );
      const value = generateNewIri(initialValue, existingIris);

      return {
        text,
        value,
        isNewlyCreated: true,
        directions: [],
      };
    },
    [existingIris, generateNewIri, project]
  );
};
